import React, { useState, useEffect } from "react";
import Admin from "./Admin";
import "../../styles/admin.css";

export default function AdminLeagues({ addToast }) {
  const [leagues, setLeagues] = useState([]);
  const [selectedLeague, setSelectedLeague] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Szükséges adatok
  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const [logoUrl, setLogoUrl] = useState("");


  const handleSave = () => {
    if (!selectedLeague) {
      const newLeague = {
        name: name,
        country: country,
        logo_url: logoUrl
      };

      fetch("https://focifanatik.hu/api/admin_add_leagues.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newLeague)
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            addToast("Új liga sikeresen hozzáadva!", "success");
            handleCloseModal();

            // Frissítsük a listát
            fetch("https://focifanatik.hu/api/admin_leagues.php")
              .then(r => r.json())
              .then(d => setLeagues(d));
          } else {
            addToast("Hiba!", "warning")
          }
        })
        .catch(err => console.error("Hálózati hiba:", err));

      return; // itt megállunk, nem megyünk tovább a szerkesztéses részre
    };



    // Csak a módosított mezőket küldjük el
    const updatedData = {};
    if (name !== selectedLeague.name) updatedData.name = name;
    if (country !== selectedLeague.country) updatedData.country = country;
    if (logoUrl !== selectedLeague.logo_url) updatedData.logo_url = logoUrl;

    if (Object.keys(updatedData).length === 0) {
      addToast("Nem történt módositás!", "warning");
      return;
    }

    fetch(`https://focifanatik.hu/api/admin_update_leagues.php?id=${selectedLeague.id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          addToast("Sikeres mentés!", "success")
          handleCloseModal();

          fetch("https://focifanatik.hu/api/admin_leagues.php")
            .then((r) => r.json())
            .then((d) => setLeagues(d));
        } else {
          addToast("Hiba!", "warning")
        }
      })
      .catch((err) => console.error("Hálózati hiba:", err));

  };

  const handleDelete = (id) => {
    if (!window.confirm("Biztosan törölni szeretnéd ezt a meccset?")) return;

    fetch(`https://focifanatik.hu/api/admin_delete_leagues.php?id=${id}`, {
      method: "DELETE",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          addToast("Sikeres törlés!", "success")
          // újratöltjük a listát
          setLeagues(leagues.filter(league => league.id !== id));
        } else {
          addToast("Hiba!", "warning")
        }
      })
      .catch(err => console.error("Hálózati hiba:", err));
  };

  //Ligák lekérése
  useEffect(() => {
    // FONTOS: pontos URL
    fetch("https://focifanatik.hu/api/admin_leagues.php")
      .then((response) => response.json())
      .then((data) => {
        console.log("Kapott adatok:", data); // ← ezzel látod a böngésző konzolban, hogy tényleg jön adat
        setLeagues(data);
      })
      .catch((err) => console.error("Hiba a lekéréskor:", err));
  }, []);

  const handleOpenModal = (match) => {
    setSelectedLeague(match);
    setName(match.name);
    setCountry(match.country);
    setLogoUrl(match.logo_url);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedLeague(null);
  };

  return (
    <div className="admin-page">
      <Admin />
      <main className="admin-content">
        <header className="admin-header">
          <h3>🏆 Ligák kezelése</h3>
        </header>

        <section className="admin-main">
          <p className="text-muted">Itt tudod kezelni a ligákat.</p>

          <button
            className="btn btn-success mb-3"
            onClick={() => {
              // kiürítjük a mezőket és megnyitjuk az üres modalt
              setSelectedLeague(null);
              setName("");
              setCountry("");
              setLogoUrl("");
              setShowModal(true);
            }}
          >
            <i className="bi bi-plus-circle"></i> Új liga hozzáadása
          </button>

          <div className="table-responsive mt-4">
            <table className="table table-striped text-center align-middle">
              <thead className="table-success">
                <tr>
                  <th>ID</th>
                  <th>Név</th>
                  <th>Ország</th>
                  <th>Logó</th>
                  <th>Létrehozva</th>
                  <th>Műveletek</th>
                </tr>
              </thead>
              <tbody>
                {leagues.map((l) =>
                  <tr key={l.id}>
                    <td>{l.id}</td>
                    <td>{l.name}</td>
                    <td>{l.country}</td>
                    <td>{l.logo_url}</td>
                    <td>{l.created_at}</td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-sm btn-warning" onClick={() => handleOpenModal(l)}>
                          <i className="bi bi-pencil-square"></i> Szerkesztés
                        </button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(l.id)}>
                          <i className="bi bi-trash"></i> Törlés
                        </button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>

      {showModal && (
        <>
          {/* Sötét háttér */}
          <div className="custom-modal-backdrop"></div>

          <div className="custom-modal d-flex justify-content-center align-items-center">
            <div className="custom-modal-content">

              {/* CÍM */}
              <div className="custom-modal-header">
                <h5 className="modal-title-custom">
                  {selectedLeague ? "Liga szerkesztése" : "Új liga"}
                </h5>
                <button className="close-btn" onClick={handleCloseModal}>×</button>
              </div>


              {/* TARTALOM */}
              <div className="custom-modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Név</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>


                  <div className="mb-3">
                    <label className="form-label">Ország</label>
                    <input
                      type="text"
                      className="form-control"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Logó Url</label>
                    <input
                      type="text"
                      className="form-control"
                      value={logoUrl}
                      onChange={(e) => setLogoUrl(e.target.value)}
                    />
                  </div>

                </form>
              </div>

              {/* LÁB */}
              <div className="custom-modal-footer">
                <button className="pretty-btn cancel-btn" onClick={handleCloseModal}>
                  Mégse
                </button>
                <button className="pretty-btn save-btn" onClick={handleSave}>
                  Mentés
                </button>
              </div>


            </div>
          </div>
        </>
      )}
    </div>
  );
}
